import { constants } from "redux/constants/redux-constants";

const initialState = {
  persistChat: true,
  selectedConversation: {},
};

const chatReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.CHAT.TOGGLE_PERSIST_CHAT:
      return {
        ...state,
        persistChat: action.payload,
      };
    case constants.CHAT.SET_SELECTED_CONVERSATION:
      return {
        ...state,
        selectedConversation: action.payload,
      };
    default:
      return state;
  }
};

export default chatReducer;
